import Collections from "Components/Collections";


const Dates = () => {
  return (
    <Collections>
      <h1>Dates</h1>
    </Collections>
  );
};

export default Dates;
